import React from "react";
import Spkapexcharts from "./spk-apexcharts";

const OrderStatisticsCard = ({ Staticoptions, Staticseries, TotalSubscription }) => (
  <div className="card custom-card overflow-hidden">
    <div className="card-header pb-0 d-flex justify-content-between align-items-center">
      <h5 className="card-title mb-0">
        Subscription Statistics - {new Date().toLocaleString('default', { month: 'long' })}
      </h5>
    </div>
    <div className="card-body pt-4 px-3">
      <div className="d-flex gap-3 mb-3 flex-wrap">
        <div className="avatar avatar-md bg-primary-transparent">
          <i className="bi bi-graph-up-arrow fs-5"></i>
        </div>
        <div className="flex-fill d-flex align-items-start justify-content-between">
          <div>
            <span className="fs-11 mb-1 d-block fw-medium">TOTAL SUBSCRIPTIONS</span>
            <div className="d-flex align-items-center justify-content-between">
              <h4 className="mb-0 d-flex align-items-center">
                {TotalSubscription}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div id="orders" className="my-2" style={{ width: '100%', height: 207 }}>
        <Spkapexcharts
          chartOptions={Staticoptions}
          chartSeries={Staticseries}
          type="donut"
          width={"100%"}
          height={207}
        />
      </div>
    </div>
    <div className="card-footer border-top border-block-start-dashed">
      <div className="d-grid">
        <button className="btn btn-outline-primary fw-medium waves-effect waves-light table-icon">
          Complete Statistics
          <i className="bi bi-arrow-right ms-2 fs-16 d-inline-block"></i>
        </button>
      </div>
    </div>
  </div>
);

export default OrderStatisticsCard;
